const HTTP_PROTOCOLS = new Set(['http:', 'https:'])

const INVALID_URL_MESSAGE =
  'Link URL must be a valid http:// or https:// URL, or left empty to remove the link.'
const INVALID_SCHEME_MESSAGE = 'Link URL must use http:// or https://.'

/**
 * @param {Record<string, unknown>} payload
 * @param {{ omitNull?: boolean }} [options]
 * @returns {Record<string, unknown>}
 */
export function applySpeakerUrlToPayload (payload, { omitNull = false } = {}) {
  if (!Object.prototype.hasOwnProperty.call(payload, 'url')) {
    return payload
  }
  const urlParsed = parseSpeakerLinkUrl(payload.url)
  if (!urlParsed.valid) {
    return payload
  }
  if (urlParsed.value == null && omitNull) {
    const next = { ...payload }
    delete next.url
    return next
  }
  return { ...payload, url: urlParsed.value }
}

/**
 * @param {string | null | undefined} raw
 * @returns {{ valid: boolean, value: string | null, message?: string }}
 */
export function parseSpeakerLinkUrl (raw) {
  if (raw == null) {
    return { valid: true, value: null }
  }

  const trimmed = String(raw).trim()
  if (trimmed === '') {
    return { valid: true, value: null }
  }

  try {
    const parsed = new URL(trimmed)
    if (!HTTP_PROTOCOLS.has(parsed.protocol)) {
      return { valid: false, value: null, message: INVALID_SCHEME_MESSAGE }
    }
    return { valid: true, value: trimmed }
  } catch {
    return { valid: false, value: null, message: INVALID_URL_MESSAGE }
  }
}
